"use client";

import { LogIn } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Post-payment step of the guest bundle checkout: the purchase is paid, so
 * the only remaining action is connecting it to a Google account. The same
 * claim also works later from the emailed claim link.
 */
export function GuestCheckoutOauthStep({
  error,
  onGoogleLogin,
}: {
  error: string | null;
  onGoogleLogin: () => void;
}) {
  return (
    <>
      <DialogHeader>
        <DialogTitle>Pembayaran berhasil</DialogTitle>
        <DialogDescription>
          Login dengan Google untuk klaim Career OS Bundle kamu.
        </DialogDescription>
      </DialogHeader>
      <div className="flex flex-col items-center gap-4 py-4">
        <p className="text-center text-sm text-text-muted">
          Paket kamu sudah dibayar. Login dengan akun Google yang kamu pakai
          untuk apply kerja, biar semua alat karier langsung tersambung. Link
          klaim juga sudah kami kirim ke email kamu.
        </p>
        <Button
          type="button"
          onClick={onGoogleLogin}
          className="min-h-12 w-full gap-2 bg-brand-primary text-white hover:bg-brand-primary-hover"
        >
          <LogIn className="size-4" aria-hidden="true" />
          Login dengan Google
        </Button>
        {error ? (
          <p className="text-sm text-status-error-text" role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </>
  );
}
